// N11 (05/10/2026) — gom 4 lối chạy bot về MỘT lối chính là Kịch bản. Địa chỉ cũ không chết: khi CHƯA bật Chế độ kỹ thuật,
// #/jobs/new, #/lenh, #/bundles, #/jobs tự sang trang Kịch bản / Lịch sử chạy tương ứng (app.ts dùng history.replaceState nên Back
// không lặp). #/jobs/:id (Tiến độ lần chạy) giữ nguyên. Hàm THUẦN — không đụng DOM, test ở tests/unit/chuyen-huong.test.ts.

/** Số mã bot tối đa giữ khi chuyển hướng (địa chỉ dài vô lý bị cắt). */
export const BOT_IDS_TOI_DA = 50;
const MA_BOT = /^[A-Za-z0-9_-]{1,64}$/;

/** botIds từ địa chỉ: chỉ giữ mã khớp ^[A-Za-z0-9_-]{1,64}$ (mã lạ / có HTML bị bỏ), bỏ trùng, giữ thứ tự, tối đa 50. */
export function locBotIds(raw: string | null | undefined): string[] {
  if (!raw) return [];
  const out: string[] = [];
  for (const s of raw.split(",")) {
    const id = s.trim();
    if (!MA_BOT.test(id) || out.includes(id)) continue;
    out.push(id);
    if (out.length >= BOT_IDS_TOI_DA) break;
  }
  return out;
}

function chuan(path: string): string {
  return path.length > 1 ? path.replace(/\/+$/, "") : path;
}

/**
 * Đích chuyển hướng cho một địa chỉ cũ, hoặc null = mở trang như thường.
 * @param path phần đường của hash (không có "#" và "?…")
 * @param kyThuat Chế độ kỹ thuật đang bật (chỉ Super bật được) → trang cũ vẫn mở.
 */
export function chuyenHuong(path: string, query: URLSearchParams, kyThuat: boolean): string | null {
  const p = chuan(path);
  const ids = locBotIds(query.get("botIds"));
  const botIds = ids.length ? `botIds=${ids.join(",")}` : "";
  // Màn hình chính = Bot + Xem trực tiếp (05/10/2026): trang live đã bỏ hẳn → chuyển cả khi bật Chế độ kỹ thuật; botIds giữ để trang Bot tự mở xem các bot đó.
  if (p === "/live") return `/bots${botIds ? `?${botIds}` : ""}`;
  if (kyThuat) return null;
  switch (p) {
    case "/jobs/new": return `/kich-ban${botIds ? `?${botIds}` : ""}`;
    case "/lenh": return `/kich-ban?${botIds ? `${botIds}&` : ""}moTa=1`;
    case "/bundles": return "/kich-ban?xem=hoc-tren-bot";
    case "/jobs": return "/history";
    default: return null;
  }
}

/** Câu dải báo (hiện một lần) sau khi chuyển từ địa chỉ cũ; "" nếu không phải địa chỉ cũ. */
export function cauBaoChuyenHuong(pathCu: string): string {
  switch (chuan(pathCu)) {
    case "/jobs/new": return "“Phát lệnh mới” đã gộp vào Kịch bản — chọn kịch bản rồi bấm ▶ Chạy.";
    case "/lenh": return "“Ra lệnh bằng chữ” đã gộp vào Kịch bản — gõ mong muốn để tạo kịch bản mới, hoặc hỏi Trợ lý.";
    // (07/10/2026) phần "Kịch bản học trên bot" trên trang Kịch bản đã ẩn → chỉ chỗ còn mở được: thẻ bot.
    case "/bundles": return "“Kho kịch bản” đã gộp vào Kịch bản — kịch bản học trên bot mở từ thẻ bot (mục “Kịch bản của bot” › Mở, hoặc nút Chạy).";
    case "/jobs": return "“Lệnh chạy” đã gộp vào Lịch sử chạy.";
    case "/live": return "“Xem trực tiếp” đã gộp vào trang Bot — màn hình từng bot nằm ngay trên thẻ bot.";
    default: return "";
  }
}
